import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page29/Key/E1answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    // maxLength: 10,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      // maxLength: 4,
      textAlign: "left",
      background: "none",
      fontSize: 23,
      height: 31,
      // textTransform: "uppercase",
    },
    inputSize: 80,
    titleQuestion: [
      {
        num: "1",
        title: `Viết tiếp vào chỗ chấm cho thích hợp.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chỗ chấm để điền tên góc và cạnh thích hợp.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p29_e1.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 50px'>
        <img src='/img/FriendsPlus/Page29/E1/1.jpg' style='height:11cm; width: 24cm; margin-bottom: 20px'/>
				<div><i style='font-size:20px; color: rgb(245,54,92)'>*Ví dụ: Các góc nhọn là: góc đỉnh A, cạnh AB, AC; ...</i></div>
					<div>Trong các góc trên:</div>
					<div>- Các góc nhọn là: <input id= "0" width= "700px"></div>
					<div>- Các góc tù là: <input id= "1" width= "740px"></div>
					<div>- Các góc bẹt là: <input id= "2" width= "727px"></div>
					<div>- Các góc vuông là: <input id= "3" width= "700px"></div>
        </div>
        `,
        answer: [
          "góc đỉnh T, cạnh TQ, TB; góc đỉnh S, cạnh SP, SL | Góc đỉnh S, cạnh SP, SL; góc đỉnh T, cạnh TQ, TB",
          "góc đỉnh O, cạnh OI, OG; góc đỉnh E, cạnh ED, EK | Góc đỉnh E, cạnh ED, EK; góc đỉnh O, cạnh OI, OG",
          "góc đỉnh M, cạnh MC, MH",
          "góc đỉnh A, cạnh AV, AN",
        ],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page29/Key/E2answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 4,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      textAlign: "center",
      background: "none",
      fontSize: 23,
      height: 31,
      // textTransform: "uppercase",
    },
    inputSize: 80,
    titleQuestion: [
      {
        num: "2",
        title: `
		    `,
        color: "rgb(99,197,244)",
      },
    ],
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        a) Đếm số góc và nháy chuột vào chỗ chấm để điền câu trả lời thích hợp.<br>
        b) Kéo số vạch tương ứng với số góc thích hợp vào bảng bên dưới.

        </span>
        <video src="Audios/bt_fpt_ai/guide/p29_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 40px; max-width: 1000px'>
				<div style='display: flex'>
					<div style='line-height: 50px'>
					<div><b>a) Viết số thích hợp vào chỗ chấm.</b></div>
					<div>Hình bên có <input id= "0"> góc nhọn, <input id= "1"> góc vuông, <input id= "2"> góc tù.</div>
					</div>
					<img src='/img/FriendsPlus/Page29/E2/1.jpg' style='height:8cm; width: 21cm; margin-bottom: 20px'/>
				</div><br>
				<div>
					<b>b) Em hãy hoàn thành bảng ghi lại số góc mỗi loại tìm được ở câu a bằng các gạch, mỗi gạch là một góc.</b><br><br>
					<div style='position: relative'>
					<img src='/img/FriendsPlus/Page29/E2/2.jpg' style='height:6cm; width: 26cm; margin-bottom: 20px'/>
						<div style='position: absolute; top: 37px; left: 320px'>
							<span style='margin-right: 118px'>Góc nhọn</span>
							<span style='margin-right: 113px'>Góc vuông</span>
							<span style=''>Góc tù</span>
						</div>
						<div style='position: absolute; top: 113px; left: 107px'>
							<span style='margin-right: 152px'>Số góc</span>
							<span style='margin-right: 144px'><input id= "3"></span>
							<span style='margin-right: 124px'><input id= "4"></span>
							<span style=''><input id= "5"></span>
						</div>
					</div>
				</div>
					
        </div>
        `,
        answer: ["1", "1", "4", "1", "1", "4"],
      },
    ],
  },
};

export default json;
